import styled from 'styled-components';

import { FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Value: StyledComponent<'span'> = styled.span`
  strong {
    font-weight: ${FontWeight.Bold};
  }

  a {
    text-decoration: none;
  }
`;
